import {allCountries, Country} from "country-telephone-data";
import {MembershipsInTour} from "../models/membership";
import {UserRole} from "../models/account";

export const isoToFlag = (isoCode: string): string =>
    isoCode
        ? isoCode
            .toUpperCase()
            .replace(/./g, (char: string) => String.fromCodePoint(char.charCodeAt(0) + 127397))
        : "";

// ✅ Direkt berechnen, kein useMemo nötig
export const dialOptions = [...allCountries]
    .sort((a: Country, b: Country) => parseInt(a.dialCode) - parseInt(b.dialCode))
    .map(({iso2, name, dialCode}) => ({iso2, name, dialCode}));


export function areOtherAdminsOrCreatorsInTour(
    membershipsInTour: MembershipsInTour,
    myAccountId: number
): boolean {
    return membershipsInTour.memberships.some(m =>
        m.accountId !== myAccountId &&
        (m.userRole === UserRole.ADMIN || m.userRole === UserRole.CREATOR)
    );
}
